<div id="header" class="w-100 py-4 px-4 position-fixed" #header>
  <div class="container-fluid">
    <div class="d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center justify-content-between">
        <a [routerLink]="['/']">
          <img src="assets/img/nmosd-topbar-logo.svg" class="img-fluid" />
        </a>
      </div>
      <div ngbDropdown class="d-inline-block">
        <a class="avatar-dropdown" ngbDropdownToggle>
          <img
            class="avatar rounded-circle img-fluid"
            src="assets/img/header-avatar.svg"
            alt="avatar"
        /></a>
        <div
          class="dropdown-hcp bg-white"
          ngbDropdownMenu
          aria-labelledby="dropdownBasic1"
        >
          <div class="d-flex align-items-center dropdown-hcp__content">
            <img
              class="img-fluid"
              src="assets/img/header-avatar.svg"
              alt="avatar"
            />
            <div class="ms-3 flex-fill overflow-hidden">
              <span class="fw-medium"
                >{{
                  me.professionalTitle
                    ? professionalTitleMapping[me.professionalTitle] + " "
                    : ""
                }}{{ me.firstName }} {{ me.lastName }}</span
              >
              <span
                title="{{ me.email }}"
                class="d-block dropdown-hcp__content__email text-truncate"
                >{{ me.email }}</span
              >
            </div>
          </div>
          <hr />
          <button ngbDropdownItem (click)="openSettings()">
            <img
              class="icon-header"
              src="assets/icons/icon_account.svg"
              alt="icon"
            />
            <span i18n="@@common_profileMenu_accountManagementLink"
              >Account management</span
            >
          </button>
          <button ngbDropdownItem (click)="logout()">
            <img
              class="icon-header"
              src="assets/icons/icon_signout.svg"
              alt="icon"
            />
            <span i18n="@@common_profileMenu_signOutLink">Log out</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
